/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UpdateSigintSignalForm = {
  /**
   * Replacement classifier criteria; empty clears it
   */
  classifierCriteria?: string | undefined;
  /**
   * Replacement description; empty clears it
   */
  description?: string | undefined;
  /**
   * Signal ID
   */
  id: string;
  /**
   * Replacement display name; trimmed before enforcing the 1 to 200 character limit
   */
  name?: string | undefined;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug?: string | undefined;
};

/** @internal */
export type UpdateSigintSignalForm$Outbound = {
  classifier_criteria?: string | undefined;
  description?: string | undefined;
  id: string;
  name?: string | undefined;
  slug?: string | undefined;
};

/** @internal */
export const UpdateSigintSignalForm$outboundSchema: z.ZodMiniType<
  UpdateSigintSignalForm$Outbound,
  UpdateSigintSignalForm
> = z.pipe(
  z.object({
    classifierCriteria: z.optional(z.string()),
    description: z.optional(z.string()),
    id: z.string(),
    name: z.optional(z.string()),
    slug: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      classifierCriteria: "classifier_criteria",
    });
  }),
);

export function updateSigintSignalFormToJSON(
  updateSigintSignalForm: UpdateSigintSignalForm,
): string {
  return JSON.stringify(
    UpdateSigintSignalForm$outboundSchema.parse(updateSigintSignalForm),
  );
}
